import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PorteurService } from "./porteur.service";
import { Porteur } from "./porteur";

@Injectable({
  providedIn: 'root'
})
export class PorteurResolver {
  constructor(
    private porteurService: PorteurService,
        private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Porteur> {
    let numPorteur;
    if (route.params['numPorteur']) {
      numPorteur = route.params['numPorteur'];
    } else {
      numPorteur = route.parent.params['numPorteur'];
    }
    try {
      return this.porteurService.getPorteur(numPorteur);
    } catch {
      this.router.navigate(["/escli/daily-operation/vt/porteurs"])
    }
  }

}
